import { GLServiceBase, ServiceRoute, GLUtil } from "commonui";
import {
	ContentSimpleModel,
	IResourceService,
	VCSLevelResponseModel,
	LetterPhonogramCard,
	ContentSimpleDataModel,
	PDFViewerPageReferencesModel,
	PageSettings
} from ".";

class ResourceServiceClass extends GLServiceBase<any, any> implements IResourceService {
	serviceRoute: ServiceRoute = { prefix: "content/v1/resource" };

	getLessonPlanContents(params: any): Promise<ContentSimpleModel[]> {
		return this.get("lessonplan/contents", params);
	}

	getContentExposureRelatedItemContents(params: any): Promise<ContentSimpleDataModel> {
		return this.get("contentexposure/relateditem/contents", params);
	}

	getClassRoomMaterialsContents(params: any): Promise<ContentSimpleModel[]> {
		return this.get("versions/{versionId}/vcsLevels/{vcsLevelId}/classroommaterialscontents", params);
	}

	getContentExposureRelatedVCSLevels(params: any): Promise<VCSLevelResponseModel[]> {
		return this.get("contentexposure/relatedvcslevels", params);
	}

	getLetterphonogramcards(params: any): Promise<LetterPhonogramCard[]> {
		return this.get(
			"versions/{versionId}/vcsLevels/{startVCSLevelId}/{endVCSLevelId}/letterphonogramcards",
			params
		);
	}

	getUnitOverviewPhonograms(params: any): Promise<LetterPhonogramCard[]> {
		return this.get("versions/{versionId}/vcsLevels/{vcsLevelId}/unitoverview/phonograms", params);
	}

	getContentExposureContents(params: any): Promise<any[]> {
		return this.get("contentexposure/contents", params);
	}

	getDownloadMediaUrl(mediaId: string): Promise<string> {
		return this.get("GetDownloadMediaUrl", { mediaId });
	}

	getDownloadPageUrl(pageId: string): Promise<string> {
		return this.get("GetDownloadPageUrl", { pageId });
	}

	getPdfImages(mediaId: string): Promise<PDFViewerPageReferencesModel> {
		return this.get("GetPDFMediaImages", { mediaId });
	}

	savePageSettings(params: PageSettings[], phonogram?: string, phonogramWord?: string): Promise<boolean> {
		var query = "";

		if (phonogram) {
			query = `?phonogram=${phonogram}`;
		} else if (phonogramWord) {
			query = `?phonogramWord=${phonogramWord}`;
		}

		return this.update("SavePageSettings" + query, params);
	}
}

export const ResourceService = new ResourceServiceClass();
